import React, { useEffect, useState } from "react";
import { Container, Col, Row } from "react-bootstrap";
import { FaMagnifyingGlass } from "react-icons/fa6";
import MobileView from "../../components/MobileView";
import TableUI from "../../components/Table";
import { TextInputForm } from "../../components/Forms";
import { ClickButton } from "../../components/ClickButton";
import API_DOMAIN from "../../config/config";
import { useMediaQuery } from "react-responsive";
import { useNavigate } from "react-router-dom";
import LoadingOverlay from "../../components/LoadingOverlay";

const DanceClassBill = () => {
  const navigate = useNavigate();
  const tableHead = ["No", "Date", "Bill No", "Class Name", "Amount", "Action"];
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${API_DOMAIN}/dance_class_bills.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          search_text: searchText,
        }),
      });

      const responseData = await response.json();

      setLoading(false);
      if (responseData.head.code === 200) {
        setData(responseData.body.bills || []);
      } else {
        // Handle case where no bills found or error, but keep array empty
        setData([]);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching data:", error.message);
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchText]);

  const handleSearch = (value) => {
    setSearchText(value);
  };

  return (
    <div>
      <Container fluid>
        <Row>
          <Col lg="7" md="4" xs="6">
            <div className="page-nav py-3">
              <span className="nav-list">Dance Class Bill</span>
            </div>
          </Col>
          <Col lg="5" md="3" xs="6" className="align-self-center text-end">
            <ClickButton
              label={<>Add New</>}
              onClick={() => navigate("/console/master/danceclassbill/create")}
            />
          </Col>

          <Col lg="3" md="5" xs="12" className="py-1">
            <TextInputForm
              placeholder={"Search by Name, Bill No..."}
              onChange={(e) => handleSearch(e.target.value)}
              prefix_icon={<FaMagnifyingGlass />}
            >
              {" "}
            </TextInputForm>
          </Col>

          {loading ? (
            <LoadingOverlay isLoading={loading} />
          ) : (
            <>
              <Col lg="12" md="12" xs="12" className="px-0">
                <div className="py-1">
                  {isMobile &&
                    data.map((item, index) => (
                      <MobileView
                        key={index}
                        sno={item.id}
                        name={item.child_name || item.parent_name}
                        subname={item.dance_class_bill_no}
                      />
                    ))}
                  <TableUI
                    headers={tableHead}
                    body={data}
                    type="danceClassBill"
                    pageview={"yes"}
                  />
                </div>
              </Col>
            </>
          )}
        </Row>
      </Container>
    </div>
  );
};

export default DanceClassBill;
